export * from "-!../../node_modules/babel-loader/lib/index.js!../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ItemView.vue?vue&type=template&id=bea1e2dc&"


//////////////////
// WEBPACK FOOTER
// ./src/views/ItemView.vue?vue&type=template&id=bea1e2dc&
// module id = 533
// module chunks = 3